import { render, staticRenderFns } from "./sysg.vue?vue&type=template&id=0a4df00c&scoped=true&"
import script from "./sysg.vue?vue&type=script&lang=js&"
export * from "./sysg.vue?vue&type=script&lang=js&"
import style0 from "./sysg.vue?vue&type=style&index=0&id=0a4df00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4df00c",
  null
  
)

export default component.exports